import { useParams } from 'react-router';
import { NotFound, PageWrapper } from '@britishcouncil/react-admin';
import { Grid, Segment } from 'semantic-ui-react';
import styled from '@emotion/styled';

import { ROUTING_PATHS } from 'const';
import { ProtectedPage } from 'components';
import { isValidBulkDataType } from 'types';
import { BULK_ACTION_CONFIGS } from './bulkActionConfig';
import { LastUploadsListSegment, TemplateSegment, UploadSegment } from './components';

const { bulkActions } = ROUTING_PATHS;

export const BulkActionsPage = () => {
  const { bulkDataType } = useParams<{ bulkDataType: string }>();

  if (!isValidBulkDataType(bulkDataType)) {
    return <NotFound />;
  }

  const config = BULK_ACTION_CONFIGS[bulkDataType];
  const requiresAll = bulkActions[bulkDataType].requiresAll;

  return (
    <ProtectedPage requiresAll={requiresAll}>
      <PageWrapper>
        <Segment>
          <Grid as={Grid} stackable columns={2}>
            <S.FirstColumn>
              <TemplateSegment templateKey={config.templateKey} />
              <UploadSegment bulkDataType={bulkDataType} />
            </S.FirstColumn>

            <Grid.Column>
              <LastUploadsListSegment bulkDataType={bulkDataType} />
            </Grid.Column>
          </Grid>
        </Segment>
      </PageWrapper>
    </ProtectedPage>
  );
};

const S = {
  FirstColumn: styled(Grid.Column)`
    .ui.grid > &.column:not(.row) {
      padding-left: 4vw;
      padding-right: 4vw;
    }
  `,
};
